export const LATENCY_NUMBER_REQUESTS = 20;

export const UPLOAD_NUMBER_REQUESTS = 20;
export const UPLOAD_PARALLEL_REQUESTS = 5;
export const UPLOAD_REQUEST_SIZE = 500_000;

export const DOWNLOAD_NUMBER_REQUESTS = 20;
export const DOWNLOAD_PARALLEL_REQUESTS = 5;
export const DOWNLOAD_REQUEST_SIZE = 5_000_000;
